import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';
import { MyAccountBreadcrumbsTemplate } from './MyAccountBreadcrumbsTemplate';
import { rem } from 'polished';
import { isBrandAC, isBrandAP, isBrandDS, isBrandOV } from '../../constants/main';
import { StylesAC } from './Styles.AC';
import { StylesAP } from './Styles.AP';
import { StylesDS } from './Styles.DS';
import { StylesOV } from './Styles.OV';

export const MyAccountBreadcrumbs = styled(MyAccountBreadcrumbsTemplate)`
    display: flex;
    flex: none;
    padding: ${rem('10px')} 0;
    margin-bottom: ${rem('16px')};

    width: 100%;

    @media (min-width: ${breakpoints.lg}px) {
        width: fit-content;
    }

    ${isBrandAC && StylesAC};
    ${isBrandAP && StylesAP};
    ${isBrandDS && StylesDS};
    ${isBrandOV && StylesOV};
`;
